module.exports = __webpack_public_path__ + "8aa6818b.png";